import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import KimLogo from './assets/kim-logo-transparent.png';
import axiosInstance from './client/axios.js';
import HelpdeskFrame from './assets/helpdesk_frame.webp';
import HelpdeskCover from './assets/helpdesk_cover2.webp';

const OauthLogin = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [searchParams] = useSearchParams();

  //   const [isLoading, setIsLoading] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [loadedImage, setLoadedImage] = useState(HelpdeskCover);
  const allParams = new URLSearchParams(searchParams);

  const clientId = allParams.get('client_id');
  const redirectUri = allParams.get('redirect_uri');
  const state = allParams.get('state');
  const kimClientId = process.env.REACT_APP_KIM_CLIENT_ID;

  const handleLogin = async () => {
    setIsLoggingIn(true);
    try {
      const email = document.getElementById('email').value;
      const password = document.getElementById('password').value;

      const response = await axiosInstance.post(
        `/oauth/login?${allParams.toString()}`,
        { email, password, state, redirectUri },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log(response, 'response');
      window.location.href = response.data.redirectUrl;
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message ||
          'An error occurred during login. Please try again.'
      );
      console.log('Error during login:', error);
    } finally {
      setIsLoggingIn(false);
    }
  };

  useEffect(() => {
    const img = new Image();
    img.src = HelpdeskFrame;
    img.onload = () => {
      if (img.complete) {
        setLoadedImage(HelpdeskFrame);
      }
    };
  }, []);

  if (clientId !== kimClientId) {
    return <div>Invalid client id</div>;
  }

  return (
    <div
      style={{
        backgroundImage: `url(${loadedImage})`,
        backgroundSize: 'cover',
        backgroundPositionY: 'top',
      }}
      className="flex justify-center items-center min-h-screen bg-center p-4 relative bg-no-repeat backdrop-blur-[12px]"
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/70"></div>

      <div className="form px-4 py-12 sm:p-12 rounded-md w-full max-w-md bg-white shadow-xl relative z-10">
        <img src={KimLogo} alt="Kim Logo" className="w-1/4 sm:w-1/4 mb-4" />
        <h2
          className="text-xl sm:text-2xl font-semibold mb-4 sm:my-8 text-left"
          style={{ color: '#272727' }}
        >
          Welcome back!
        </h2>
        <form className="flex flex-col space-y-4">
          <input
            type="text"
            id="email"
            placeholder="Your Email"
            className="py-2 px-4 border border-[#d9d9d9] rounded-lg placeholder-[#948F8F]"
          />
          <input
            type="password"
            id="password"
            placeholder="Password"
            className="py-2 px-4 border border-[#d9d9d9] rounded-lg placeholder-[#948F8F]"
          />
          {errorMessage && (
            <div className="text-red-500 text-center text-sm">
              {errorMessage}
            </div>
          )}
          <button
            type="button"
            onClick={handleLogin}
            disabled={isLoggingIn}
            className="bg-[#fabf01] text-[#272727] px-3 py-2 font-medium rounded-lg shadow-lg flex items-center justify-center"
          >
            {isLoggingIn ? (
              <>
                <div className="loader mr-2 w-4 h-4 border-2 border-white border-t-[#085454] rounded-full animate-spin"></div>
                Loggin In...
              </>
            ) : (
              'Login'
            )}
          </button>
        </form>
        {/* <p className="text-gray-600 sm:text-sm text-center mt-6">
          Don&apos;t have an account?{' '}
          <Link
            to={`/signup${location.search}`}
            className="text-[#085454] font-medium underline underline-offset-4"
          >
            Sign Up
          </Link>
        </p> */}
      </div>
    </div>
  );
};

export default OauthLogin;
